module.exports = __webpack_public_path__ + "static/img/egg_g_13.5279f95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/g/egg_g_13.png
// module id = EFL3
// module chunks = 1